import { DateTime } from "luxon";

import { SettlementScheduleTypes } from "../../constants/SettlementScheduleTypes";

import type { ScheduleConfigurationItem } from "../../models/ScheduleConfigurationForm";
import type { SettlementScheduleConfigType } from "../../models/SettlementScheduleConfig";

export function getScheduleDefinitionForType(
  type: SettlementScheduleConfigType,
  values: Partial<ScheduleConfigurationItem>
) {
  const timeWithSeconds = !!values.time
    ? DateTime.fromFormat(values.time, "HH:mm").toFormat("HH:mm:ss")
    : null;

  switch (type) {
    case SettlementScheduleTypes.HOURLY:
      return {
        startTime: timeWithSeconds,
        interval: values.frequency,
      };
    case SettlementScheduleTypes.DAILY:
      return {
        time: timeWithSeconds,
      };
    case SettlementScheduleTypes.WEEKLY:
      return {
        time: timeWithSeconds,
        weekday: values.weekday,
      };
    case SettlementScheduleTypes.MONTHLY:
      return {
        time: timeWithSeconds,
        monthday: values.day,
      };
    default:
      throw new Error(`Unknown type ${type}`);
  }
}
